import { SolidifyableData } from "../../../../../core/data/SolidifyableData";
import { GameConstants } from "../../constant/GameConstants";
import { ProgressiveJackpotData } from "./ProgressiveJackpotData";
/**
 * ProgressiveJackpotResponseData.ts
 */
export class ProgressiveJackpotResponseData extends SolidifyableData {
    solidify() {
        super.solidify();
        this.solidifyJackpots();
    }
    solidifyJackpots() {
        this.jackpots = [];
        let jackpots = this.data.getDataArray(GameConstants.PROPERTY_PROGRESSIVE_JACKPOTS);
        if (jackpots) {
            for (let i = 0; i < jackpots.length; i++) {
                this.jackpots.push(new ProgressiveJackpotData(jackpots[i]));
            }
        }
    }
    getJackpots() {
        return this.jackpots;
    }
}
//# sourceMappingURL=ProgressiveJackpotResponseData.js.map